<template>
  <div>
    <v-tabs
      dark
      slider-color="red"
    >
      <v-tab
        v-for="tab in tabs"
        :key="`tab-${tab.route}`"
        ripple
        :to="{ name: tab.route }"
      >
        {{ tab.name }}
      </v-tab>
    </v-tabs>
    <v-card>
      <router-view />
    </v-card>
  </div>
</template>

<script>
  export default {
    name: 'listingInvitation',
    data () {
      return {
        tabs: [
          {
            name: 'Single Invitation',
            route: 'listing single invitation'
          },
          {
            name: 'Multiple Invitation',
            route: 'listing multiple invitation'
          }
        ]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/Listing/ListingInvitation/index.vue